<style scoped>

.dialog_title {
  display: flex;
  align-items: center;
  color: #1a1a1a;
}

.dialog_t {
  font-size: 18px;
  margin-left: 20px;
}

.icon-close {
  font-size: 24px;
  cursor: pointer;
  color: #7e84a3;
}
.dialog_confirm {
  margin: 0 0 0 auto;
  font-size: 15px;
}
</style>

<template>
  <el-drawer size="420px" :visible.sync="visible" custom-class="dialog_device common_drawer" direction="rtl"
             :showClose="false" :wrapperClosable="false">
    <span slot="title" class="dialog_title">
      <i class="el-icon-close icon-close" @click="visible = false"></i>
      <span class="dialog_t">{{
          spaceForm.id ? "编辑区域" : "添加区域"
        }}</span>
      <div class="dialog_confirm">
        <el-button class="add-confirm_a" @click="visible = false" style="background: none">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="handleSubmit" class="add-confirm_a">确认</el-button>
      </div>
    </span>
    <div style="padding: 20px;">
      <el-form class="form_device" :model="spaceForm" label-position="top" ref="spaceForm"
               :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="spaceForm.name" maxlength="64"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="spaceForm.remark" type="textarea" rows="4"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>


<script>
import {SpaceApi} from "@/api/server/space";

export default {
  components: {},
  data() {
    return {
      visible: false,
      loading: false,
      spaceForm: {
        name: null,
        remark: null
      },
      rules : {
        name: [
          { required: true, message: '请输入设备名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        sn: [
          { required: true, message: '请输入云序列号', trigger: 'blur' },
          { min: 16,}
        ]
      }
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    show(row){
      this.spaceForm = Object.assign({id: null,name: null, remark: null}, row);
      this.visible = true;
    },
    handleSubmit(){
      this.$refs.spaceForm.validate(valid => {
        if (valid) {
          SpaceApi.save(this.spaceForm).then(res => {
            if(res.code == 200){
              this.$message.success("保存成功");
              this.$emit("success");
              this.visible = false;
            }else{
              this.$message.error(res.message || '保存失败');
            }
          })
        }
      });
    }
  }
};
</script>